module.exports = __webpack_public_path__ + "static/media/FrutigerNeueLTW04-Book.e7db9595.ttf";